import { useCallback, useRef, useState } from 'react';

const SCROLL_TO_BOTTOM_OFFSET = 200;

export const useScrollToBottom = () => {
  const dummyRef = useRef<HTMLDivElement>(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);

  const scrollToBottom = useCallback((behavior: ScrollBehavior = 'smooth') => {
    dummyRef.current?.scrollIntoView({ behavior });
  }, []);

  const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    setShowScrollToBottom(
      scrollHeight - scrollTop > clientHeight + SCROLL_TO_BOTTOM_OFFSET
    );
  }, []);

  return {
    dummyRef,
    showScrollToBottom,
    scrollToBottom,
    handleScroll,
  };
};
